export default __webpack_public_path__ + "static/media/signalseting.ee5df06b.png";